export default __webpack_public_path__ + "static/media/Logo-Full.3d8a15f4.png";